export default "__VITE_ASSET__CnmVLljD__"